export default function (rehydrated) {
  // 統一 中文判別
  if (rehydrated.state.user.selectedLang === 'zh-TW') {
    rehydrated.commit('user/SET_LANG', 'zh_TW')
  }
}
